const Coachees = function ($location, $scope, localize) {
  const $ctrl = this;

  $ctrl.localize = localize;
  $ctrl.filterString = '';
  $ctrl.people = [];

  $ctrl.getFilteredPeople = function () {
    if ($ctrl.filterString.isEmpty || !$ctrl.people || $ctrl.people.length === 0) {
      return $ctrl.people;
    } else {
      return $ctrl.people.filter(person => person.name.toUpperCase().indexOf($ctrl.filterString.toUpperCase()) !== -1);
    }
  };

  $ctrl.clickedPerson = function (person) {
    $scope.$evalAsync(() => {
      let path = '/coachee/' + person.id;
      $location.path(path)
    });
  };

};

export default {
  name: 'coachees',
  obj: {
    controller: Coachees,
    templateUrl: 'components/coachees.html',
    bindings: {
      people: '<'
    }
  }
};